import type { Router, } from 'vue-router';
import {
  captureRouteContentError,
  clearRouteContentError,
} from '@/router/routeError';

export default function createErrorGuard(router: Router) {
  router.onError((error) => {
    console.error('[router] navigation failed', error);
    captureRouteContentError('router');
  });

  router.afterEach((_to, _from, failure) => {
    if (!failure) {
      clearRouteContentError();
    }
  });
}
